import { FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import { Navigate } from 'react-router-dom';
import { useFeatureFlag } from '@hooks';
import React from 'react';
export const FeatureRouteWrapper = ({ children, feature, fallback }) => {
    const isFeatureEnabled = useFeatureFlag(feature);
    return isFeatureEnabled ? children : fallback !== null && fallback !== void 0 ? fallback : React.createElement(Navigate, { to: FULL_ROUTES.DASHBOARD });
};
